import React from 'react'
// import InlineSVG from 'svg-inline-react'
import classNames from 'classnames'

import { CartsAppContext } from '../context/carts-app-context'
import {
  // getRecommendedMembership,
  sumCartItems,
  membershipInCart,
  allItemsHaveMembershipTickets,
  // isChildLearning,
  notMembershipType,
  isMissingRequiredNotes,
  isMissingRequiredPreferredRecognition
} from '../helpers/logic'
// import cardIcon from '../../../images/card.svg'
import { isMembershipType } from '../helpers/logic'
import { ticketsWithConstituencyPricing } from '../../shared/helpers/logic'
import { includesEmployee } from '../../tickets/helpers/logic'

const cantContinue = (cartHasMembership, items) =>
  cartHasMembership && !allItemsHaveMembershipTickets(items)

/**
 *
 * @param props {Object} properties passed to the component from its parent
 * @param props.membership {string} the recommended membership
 * @returns {JSX.Element}
 * @constructor
 */
// const MembershipCTA = props => (
//   <React.Fragment>
//     <p className="my-40 h-0 border-t font-bold text-12 text-center">
//       <span
//         className="table mx-auto px-8 bg-white"
//         style={{ transform: 'translateY(-50%)' }}
//       >
//         OR
//       </span>
//     </p>
//     <p className="flex text-14">
//       <SVG
//         src={cardIcon}
//         className="mr-16 flex-shrink-0"
//         aria-hidden="true"
//         aria-label="card"
//       />
//       <span>
//         Save on admission on this and every visit with a Membership. Based on
//         your party, we recommend a{' '}
//         <span className="font-bold">{props.membership} Membership</span>.
//       </span>
//     </p>
//     <a
//       data-testid="membership-button"
//       href="/membership_plans"
//       className="button -big -dark w-full px-16 mt-20"
//     >
//       Get a Membership
//     </a>
//   </React.Fragment>
// )

class OrderActions extends React.Component {
  state = {
    loading: false
  }

  proceedToCheckout = saveCart => () => {
    this.setState({ loading: true })
    saveCart()
  }

  render() {
    return (
      <CartsAppContext.Consumer>
        {({
          actions: { saveCart },
          cart,
          updateNeeded,
          inProgressUpdateCount
        }) => {
          const {
            membership,
            // maxChildren,
            // maxAdults,
            // illinoisResidents,
            items,
            exchangeDetails
          } = cart

          // const childLearningInCart = items
          //   .filter(notMembershipType)
          //   .some(item => isChildLearning(item.pricing.member))

          // let membershipRec = null
          const cartHasMembership = membershipInCart(items) || membership.active
          const eventItems = cart.items.filter(notMembershipType)

          // if (!membership.active) {
          //   // does the cart have illinois/chicago resident tickets
          //   if (eventItems.length > 0 && !illinoisResidents) {
          //     membershipRec = getRecommendedMembership(
          //       maxAdults,
          //       maxChildren,
          //       childLearningInCart
          //     )
          //   }
          // }

          const exchangeCredit = parseFloat(
            exchangeDetails?.exchangeAmount || 0
          )
          let computedTotal = sumCartItems(items) + exchangeCredit

          // If this is an exchange, then the subTotal is always the sum of the
          // items in the cart - the exchange credit.  Since users never get money back
          // if the value is < 0, it's just 0.
          if (cart.exchange) {
            if (computedTotal < 0) {
              computedTotal = 0
            }
          }

          // Add the exchange fee in AFTER zeroing out the cart if needed.
          computedTotal += cart.exchangeFee

          let isMissingNoteOrPrefferedRec =
            isMissingRequiredNotes(cart) ||
            isMissingRequiredPreferredRecognition(cart.items)
              ? true
              : false

          const cantContinueConstTickets = items => {
            const eventItems = items.filter(item => !isMembershipType(item))
            let hasEmployeeTickets = false
            let hasConstituencyTickets = false
            let constituencyTickets = []
            eventItems.forEach(item => {
              constituencyTickets.push(
                ticketsWithConstituencyPricing(item.tickets)
              )
              if (constituencyTickets.flat().length > 0) {
                hasConstituencyTickets = true
              }
              if (includesEmployee(item.tickets)) hasEmployeeTickets = true
            })
            constituencyTickets = constituencyTickets.flat()
            return (
              constituencyTickets.length > 1 ||
              (hasEmployeeTickets && hasConstituencyTickets)
            )
          }

          let cantContinueConstituencyTickets = cantContinueConstTickets(
            cart.items
          )

          let disableNextButton =
            this.state.loading ||
            inProgressUpdateCount > 0 ||
            (cantContinue(cartHasMembership, eventItems) && updateNeeded) ||
            isMissingNoteOrPrefferedRec ||
            cantContinueConstituencyTickets

          const nextStepButtonText =
            computedTotal === 0 && eventItems.length === cart.items.length
              ? 'Reserve Tickets Now'
              : 'Proceed to Secure Checkout'

          const buttonClassNames = classNames('button -big w-full px-12', {
            '-disabled': disableNextButton
          })

          return (
            <React.Fragment>
              <button
                className={buttonClassNames}
                onClick={this.proceedToCheckout(saveCart)}
                disabled={disableNextButton}
                data-testid="proceed-to-checkout"
              >
                {this.state.loading ? 'Loading...' : nextStepButtonText}
              </button>

              {isMissingNoteOrPrefferedRec && (
                <span className="text-12">
                  You are missing a required field for one of the items in your
                  cart. Please review your items; required fields are marked
                  with an "*".
                </span>
              )}
              {/* SHEDDWEB-1458 Remove membership CTA from PP */}
              {/*{membershipRec && <MembershipCTA membership={membershipRec} />}*/}
            </React.Fragment>
          )
        }}
      </CartsAppContext.Consumer>
    )
  }
}

export default OrderActions
